import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainView
  },
  {
    path: '/attendance',
    name: 'Anwesenheit',
    component: MainView
  },
  {
    path: '/mealplanning',
    name: 'Essensplanung',
    component: MainView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
